import styled, { css } from "styled-components";

export const MultiFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  border-top: 1px solid rgba(81, 83, 86, 1);
  background: rgba(52, 53, 56, 1);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  font-size: 12px;
  button {
    height: 24px;
  }
  > *:first-child {
    margin-right: 8px;
  }
`;

export const MultiCheckAll = styled.div`
  border-bottom: 1px solid rgba(81, 83, 86, 1);
  background: rgba(52, 53, 56, 1);
  height: 36px;
  display: flex;
  align-items: center;
  padding-left: 9px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`;

export const SelectWrapper = styled.div`
  background: yellow;
`;
export const Option = styled.div`
  width: 100%;
  &.task-eva-select-option {
    &.disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;
export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const customCSS = css``;
